module.exports = __webpack_public_path__ + "static/onesignal-dc1182ee78714d985f74473e642b423f.png";